import React from "react";

import { Icon } from "@iconify/react";

function Lotus() {
  return (
    <div className="mt-5 d-flex justify-content-center lotus">
      <Icon icon="ph:flower-lotus-thin" className={`lotus`} />
    </div>
  );
}

export default Lotus;
